// extracted by mini-css-extract-plugin
export default {"img-box":"CircleOrangeImg_img-box__nJaBQ"};